import intl from 'react-intl-universal';
import _ from 'lodash-es';
import { Button, Col, Flex, Row, Space, Avatar, Spin, Alert } from "antd";
import { LeftOutlined, RightOutlined, UserOutlined, PlusOutlined, CheckCircleFilled } from '@ant-design/icons';
import {useEffect, useState} from "react";

import request from "../../../libs/request";
import Themes from "../../../styles/Themes";

const DependantList = ({onNext, onPrevious, data, isMobileWebview}) => {
    const [loading, setLoading] = useState(false);
    const [ready, setReady] = useState(false);
    const [familyMembers, setFamilyMembers] = useState(_.without(_.get(data, "dependant_list.value", []), null));
    const [errorMessage, setErrorMessage] = useState(null);

    var activeItemStyle = {
        color: Themes.getPrimaryColor(),
        borderColor: Themes.getPrimaryColor()
    }

    const renderFamilyMembers = () => {
        var members = [];
        for (let i in familyMembers) {
            let member = familyMembers[i];
            members.push(
                <Col md={8} key={ member["id"] }>
                    <div
                        className="item"
                        style={member.selected ? activeItemStyle : {}}
                        onClick={() => {
                            var newFamilyMembers = _.map(familyMembers, mem => {
                                _.unset(mem, "selected");
                                return mem;
                            });
                            newFamilyMembers[i]["selected"] = true;
                            setFamilyMembers(newFamilyMembers);
                        }}
                    >
                        <Avatar
                            className="item-avatar"
                            size="large"
                            icon={<UserOutlined />}
                        />
                        <div className="selected-item">
                            { member.selected && <CheckCircleFilled /> }
                        </div>
                        <span className="username">
                            { member["full_name"] }
                        </span>
                    </div>
                </Col>
            );
        }
        return members;
    }

    useEffect(() => {
        const loadFamilyMembers = async () => {
            var usersToBeAdded = [];
            if (!_.find(familyMembers, {id: window.user.id})) {
                window.user.selected = true;
                usersToBeAdded.push(window.user);
            }

            if (_.get(window.CONFIG, 'Account.dependant.enabled')) {
                // should send a request to get dependants with credentials from token parent
                const res = await fetch(`${window.base_url}/api_v3/users/-/dependants`, {
                    method: "GET",
                    headers: {
                        "X-ApiToken": window.user.token,
                        "X-AccountCode": window.CONFIG.Account.code
                    },
                    credentials: "omit"
                });
                const respJson = await res.json();
                var dependants = respJson["data"] ? respJson["data"] : [];
                for (var i in dependants) {
                    if (!_.find(familyMembers, {id: dependants[i]["id"]})) {
                        usersToBeAdded.push(dependants[i]);
                    }
                }
                if (usersToBeAdded.length > 0) {
                    setFamilyMembers(_.concat(familyMembers, usersToBeAdded));
                }
            }
            setReady(true);
        }

        loadFamilyMembers();
        // eslint-disable-next-line
    }, []);

    const onSubmit = async () => {
        setLoading(true);
        const selected = _.find(familyMembers, {selected: true});
        
        if (selected.caretakers) {
            const res = await fetch(`${window.base_url}/api_v3/users/-/dependants/${_.get(selected, 'id')}/login`, {
                method: "POST",
                headers: {
                    "X-ApiToken": window.user.token,
                    "X-AccountCode": window.CONFIG.Account.code
                },
                credentials: "omit"
            }).catch(err => {
                setErrorMessage(_.get(err, "response.data.error", "An error occurred while logging in"));
                return;
            }).finally(() => setLoading(false));

            const respJson = await res.json();
                
            if (_.get(respJson, "data.token")) {
                window.user = {
                    ...respJson.data.user, 
                    ...{
                        token: respJson.data.token
                    }
                }
            }
        }
        // selected user is the user that is selected, currently is window.user, if selected dependant is selected, login as that user
        data["user_info"] = {
            ...data["user_info"],
            value: window.user
        };
        
        onNext(familyMembers);
    }

    const createFamilyMember = () => {
        data["user_info"] = {
            ...data["user_info"],
            value: {
                caretakers: {
                    [window.user.id]: {
                        user_id: window.user.id,
                        access_readonly: false
                    }
                },
                dob: "2020-01-01"
            }
        };
        onNext(familyMembers);
    }

    return (
        <Space className="dependant-list" direction="vertical" size="middle" style={{ display: 'flex' }}>
            {!ready ?
                <div
                    className="is-spinning-loading"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        height: "20vh",
                    }}
                >
                    <Spin size="large" />
                </div> : <>
                <Row gutter={[10,0]} className="choose_patient_section">
                    {errorMessage && (
                        <Col md={24}>
                            <Alert message={errorMessage} type="error" />
                        </Col>
                    )}
                    { renderFamilyMembers() }
                    { _.get(window.CONFIG, "Account.dependant.enabled", false) && (
                        <Col md={8}>
                            <div
                                className="item add-dependant"
                                onClick={createFamilyMember}
                            >
                                <Avatar
                                    size="large"
                                    icon={<PlusOutlined />}
                                    style={{backgroundColor: Themes.getPrimaryColor()}}
                                />
                                <span className="username">Add another family member</span>
                            </div>
                        </Col>
                    ) }
                </Row>
                <Flex justify={isMobileWebview ? "center" : "space-between"}>
                    { (onPrevious != null && !isMobileWebview) ?
                        <Button onClick={ onPrevious }>
                            <LeftOutlined style={{verticalAlign:"middle"}} />
                            { intl.get("back").d("Back") }
                        </Button> : <div></div>
                    }
                    <Button
                        type="primary"
                        loading={loading}
                        shape={isMobileWebview ? "round" : "default"}
                        size={isMobileWebview ? "large" : "default"}
                        onClick={() => onSubmit()} 
                    >
                        {intl.get("continue").d("Continue")}
                        <RightOutlined style={{verticalAlign:"middle"}} />
                    </Button>
                </Flex></>
            }
        </Space>
    );
}

export default DependantList; 